import React, { useState } from 'react'
import { ConfigProvider, Select } from 'antd'
import { Colors } from '@config'
import useColors from '@hooks/useColors'
import { twMerge } from 'tailwind-merge'

const LabelWithMultipleSelect = ({ labelClass, placeholder = "", inputClass, labeltext, value, onChange, options, defaultValue, wrapperClassName = "", ...props }) => {
  const { colorPrimary } = useColors()

  // const [optValues, setOptValues] = useState([]);

  // const handleChange = (value) => {
  //   let AllValues = [];
  //   for (let opt of value) {
  //     if (opt == 'All') {
  //       console.log('All', value)
  //       for (let val of addressOption) {
  //         if (val.value == 'All') continue
  //         AllValues.push(val.value)
  //       }
  //       console.log(AllValues)
  //       setOptValues(AllValues)
  //     }
  //     else if (opt !== 'All') {
  //       setOptValues(value)
  //       console.log(value)
  //       console.log(AllValues)
  //     }
  //   }


  // }

  return (
    <div className={twMerge("flex flex-col py-4 w-full select--All--functionality", wrapperClassName)}>
      <label className={labelClass} style={{ color: Colors.LabelColor }}>{labeltext}</label>
      <ConfigProvider
        theme={{
          components: {
            Select: {
              /* here is your component tokens */
              optionSelectedBg: colorPrimary,
              selectorBg: Colors.LightGray,
              optionActiveBg: Colors.LightGray,
              optionSelectedColor: Colors.White,
              paddingSM: 28,
              colorTextPlaceholder: Colors.DarkGray
            },
          },
        }}

      >
        <Select
          defaultValue={defaultValue}
          mode="multiple"
          onChange={onChange}
          options={options}
          className={inputClass}
          showSearch={false}
          value={value}
          placeholder={placeholder}
          {...props}
        >
        </Select>
      </ConfigProvider>

    </div>

  )
}

export default LabelWithMultipleSelect

// let addressOption = [
//   {
//     label: 'All',
//     value: 'All'
//   },
//   {
//     label: 'Street',
//     value: 'Street'
//   },
//   {
//     label: 'Parkway',
//     value: 'Parkway'
//   },
//   {
//     label: 'Avenue',
//     value: 'Avenue'
//   },
//   {
//     label: 'Way',
//     value: 'Way'
//   },
//   {
//     label: 'Boulevard',
//     value: 'Boulevard'
//   },
//   {
//     label: 'Place',
//     value: 'Place'
//   },
//   {
//     label: 'Lane',
//     value: 'Lane'
//   },
//   {
//     label: 'Drive',
//     value: 'Drive'
//   },
//   {
//     label: 'Court',
//     value: 'Court'
//   },
//   {
//     label: 'Terrace',
//     value: 'Terrace'
//   },
//   {
//     label: 'Alley',
//     value: 'Alley'
//   },
//   {
//     label: 'Connector',
//     value: 'Connector'
//   },
//   {
//     label: 'Highway',
//     value: 'Highway'
//   },
//   {
//     label: 'Route',
//     value: 'Route'
//   },
//   {
//     label: 'Thruway',
//     value: 'Thruway'
//   },
//   {
//     label: 'Frontage Road',
//     value: 'Frontage Road'
//   },
//   {
//     value: 'Other',

//     label: 'Other',
//   },
// ]

